import React from 'react';
import Section from '../Section';

const SectionWrapper = (props) => {
  return (
    <Section>
      <div className="row">
        <div className="columns">{props.children}</div>
      </div>
    </Section>
  );
};

export default SectionWrapper;
